import { render, staticRenderFns } from "./FormInscripcion.vue?vue&type=template&id=79d75e55"
import script from "./FormInscripcion.vue?vue&type=script&lang=js"
export * from "./FormInscripcion.vue?vue&type=script&lang=js"
import style0 from "./FormInscripcion.vue?vue&type=style&index=0&id=79d75e55&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports